import { Injectable } from '@angular/core'
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http'
import { Observable, throwError, empty } from 'rxjs'
import { HttpUrlEncodingCodec } from './../services/auth/encoder'
import { Bond } from '@models/bond.model'
import { PossibleValue } from '@models/possible-value.model'
import { environment } from '@env/environment'
const BASE_PATH = environment.basePathExternal
const BASE_PATH_BFF = environment.basePath
/**
 * Service class to communicate with the REST services
 */
@Injectable({
  providedIn: 'root',
})
export class authService {
  constructor(
    private httpClient: HttpClient,
    private encoder: HttpUrlEncodingCodec
  ) {}
 
  hasSecurityPortfolio(): Observable<Bond> {
    return this.httpClient.get<Bond>(`${BASE_PATH}/SecurityPortfolioCtrl/hasSecurityPortfolio`)
  }
  logout(){
     return this.httpClient.post<any>(`${BASE_PATH_BFF}/bff/logout`, {})
    }
}
